// extracted by mini-css-extract-plugin
export default {"base":"FluSurveillance_base__NRjZJ","header":"FluSurveillance_header__1QGk8","content":"FluSurveillance_content__tPMwb","body":"FluSurveillance_body__qINuk"};